export const SET_CURRENT_USER_CLASS_LIST = 'SET_CURRENT_USER_CLASS_LIST';
export const ADD_TO_CURRENT_USER_CLASS_LIST = 'ADD_TO_CURRENT_USER_CLASS_LIST';
export const REMOVE_TO_CURRENT_USER_CLASS_LIST = 'REMOVE_TO_CURRENT_USER_CLASS_LIST';
export const SET_SELECTED_DAY = 'SET_SELECTED_DAY';

export const setSelectedDay = (value: any) => {
    return { type: SET_SELECTED_DAY, value }
}

export const setCurrentUserClassList = (value: any) => {
    return { type: SET_CURRENT_USER_CLASS_LIST, value }
}

export const addClassToCurrentUserClassList = (value: any) => {
    return { type: ADD_TO_CURRENT_USER_CLASS_LIST, value }
}

export const removeClassToCurrentUserClassList = (value: string) => {
    return { type: REMOVE_TO_CURRENT_USER_CLASS_LIST, value }
}
